import CreateBulkEntities from '../CreateBulkEntities'

const CreateTID = () => {
  return <CreateBulkEntities type="tid" />
}
export default CreateTID
